var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{attrs:{"name":"header-search","prependInnerIcon":"mdi-magnify"},on:{"inputOpratipon":function($event){return _vm.catchInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }